import React, { useState, useEffect } from "react";
import { Tabs, Spin, Empty, Pagination } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import BusinessList from "../../support/components/BusinessList";
import useSupportData from "../../support/hooks/useSupportData";
import AdminFulfillmentCenters from "./AdminFulfillmentCenters";

const AdminBusinessesContent = ({ useOwnLayout = false, userRole, defaultStatus }) => {
  const {
    businesses,
    loading,
    refreshData,
    businessPagination,
    fetchBusinessesWithPagination,
  } = useSupportData();
  const [activeTab, setActiveTab] = useState("restaurant");

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const businessTypeLabels = {
    restaurant: "Restaurant",
    store: "Retail",
    raw_food: "Wholesale",
    fulfillment_centers: "Fulfillment Centers",
  };

  useEffect(() => {
    if (activeTab !== "fulfillment_centers") {
      fetchBusinessesWithPagination(1, 10, { serviceType: activeTab, status: defaultStatus });
    }
  }, [activeTab, fetchBusinessesWithPagination, defaultStatus]);

  const handleViewBusiness = (business) => {
    console.log("View business:", business);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handlePageChange = (page, pageSize) => {
    fetchBusinessesWithPagination(page, pageSize, { serviceType: activeTab, status: defaultStatus });
  };

  const tabOrder = ["restaurant", "store", "raw_food", "fulfillment_centers"];
  const tabItems = tabOrder.map((key) => ({
    label: businessTypeLabels[key],
    key: key,
  }));

  return (
    <Spin spinning={activeTab !== "fulfillment_centers" && loading} indicator={antIcon}>
      <div className={useOwnLayout ? "pb-40" : ""}>
        <div className="main_container_title_div mb-5 mt-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Businesses
          </h1>
          <p className="text-gray-600 text-lg">
            Manage and monitor businesses across all categories
          </p>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          className="support-tabs"
          items={tabItems.map((tab) => ({
            label: tab.label,
            key: tab.key,
            children: (
              <div className="mt-6">
                {tab.key === "fulfillment_centers" ? (
                  <AdminFulfillmentCenters />
                ) : (
                  <>
                    {!loading && (!businesses || businesses.length === 0) && (
                      <div style={{ textAlign: "center", padding: "40px 20px" }}>
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={`No ${businessTypeLabels[tab.key].toLowerCase()} businesses`}
                        />
                      </div>
                    )}
                    {businesses && businesses.length > 0 && (
                      <>
                        <BusinessList
                          businesses={businesses}
                          loading={loading}
                          onViewBusiness={handleViewBusiness}
                          onRefresh={refreshData}
                          activeTab={tab.key}
                          userRole={userRole}
                        />
                        {businessPagination.total > 0 && (
                          <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <Pagination
                              current={businessPagination.page}
                              pageSize={businessPagination.limit}
                              total={businessPagination.total}
                              onChange={handlePageChange}
                              showSizeChanger
                              showTotal={(total, range) =>
                                `${range[0]}-${range[1]} of ${total} businesses`
                              }
                            />
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            ),
          }))}
        />
      </div>
    </Spin>
  );
};

export default AdminBusinessesContent;
